import React from "react";
import Login from "./Login";
import Signup from "./Signup";
import styled, { css } from "react-emotion";
import { fetchUserInfo } from "apis";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import { VerticalLineBreak } from "appStyles";
import { isMobileDevice } from "helpers";

const Container = styled("div")`
  opacity: 1;
  background: white;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

const invitationToken = new URLSearchParams(window.location.search).get(
  "invitationToken"
);

const mdcButton = css`
  background-color: rgb(235, 255, 255);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

const buttonStyle = css`
  background-color: rgb(235, 255, 255);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

const menuSpanStyle = css`
  text-transform: none;
`;

const AButton = styled("a")`
  text-decoration: none;
  display: inline-block;
  margin-right: 5px;
`;

class LoginSignup extends React.Component {
  state = {
    show: false,
    showSignUp: false,
    formPreFillInfo: {},
  };

  componentDidMount = async () => {
    if (invitationToken) {
      const userInfo = await fetchUserInfo(invitationToken);
      this.setState({
        ...this.state,
        formPreFillInfo: {
          ...userInfo,
          invitationToken,
        },
      });
    }
  };

  toggleModal = () => {
    if (this.props.callback) {
      this.props.callback();
    }
    this.setState({ show: false });
  };

  render() {
    const { show, showSignUp, formPreFillInfo } = this.state;

    // decides which form to render based on status of the invited user
    const shouldRenderSignup =
      formPreFillInfo.newUser === undefined || formPreFillInfo.newUser === true;
    const shouldRenderLogin =
      formPreFillInfo.newUser === undefined ||
      formPreFillInfo.newUser === false;

    // console.log("should show");
    // console.log(shouldshow);

    const { buttonText, split, isWeb, callback, customColor, loginOnly } =
      this.props;

    const isMob = isMobileDevice();

    const adminShow = !isMob;
    // const adminShow = true;
    const showControl = isWeb || adminShow;
    if (loginOnly) {
      return (
        <div
          style={{
            position: "initial",
            left: 0,
            top: 0,
            display: "inline-block",
          }}
        >
          {showControl && (
            <div>
              <AButton
                onClick={() => {
                  this.setState({ showSignUp: false, show: true });
                }}
                style={{ marginRight: "0px" }}
              >
                <Button
                  className={buttonStyle}
                  color={customColor ? "inherit" : "secondary"}
                >
                  <span className={menuSpanStyle}>Login</span>
                </Button>
              </AButton>
            </div>
          )}
          {show && (
            <Modal
              open={show}
              onClose={this.toggleModal}
              style={{
                // top: showSignUp ? "10%" : "15%",
                width: isMob ? "95%" : "50%",
                marginLeft: "auto",
                marginRight: "auto",
                height: "fit-content",
                position: "fixed",
                bottom: showSignUp ? "25%" : "50%",
                left: "0",
                top: "auto",
                overflowY: "auto",
              }}
            >
              <div style={{ backgroundColor: "white" }}>
                <div style={{ padding: "10px" }}>
                  <a
                    style={{
                      margin: "10px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    onClick={this.toggleModal}
                  >
                    X
                  </a>
                </div>
                {shouldRenderLogin && !showSignUp && (
                  <Login
                    formPreFillInfo={formPreFillInfo}
                    isWeb={isWeb}
                    customColor={customColor}
                    callback={callback}
                  />
                )}
              </div>
            </Modal>
          )}
        </div>
      );
    }

    if (split) {
      return (
        <div
          style={{
            position: "initial",
            left: 0,
            top: 0,
            display: "inline-block",
          }}
        >
          {showControl && (
            <div>
              <AButton
                onClick={() => {
                  this.setState({ showSignUp: false, show: true });
                }}
              >
                <Button
                  className={buttonStyle}
                  color={customColor ? "inherit" : "secondary"}
                >
                  <span className={menuSpanStyle}>Login</span>
                </Button>
              </AButton>
              <Button
                variant="contained"
                color={customColor ? "inherit" : "secondary"}
                style={{
                  textTransform: "none",
                  width: this.props.width ? this.props.width : "auto",
                  fontWeight: this.props.fontWeight
                    ? this.props.fontWeight
                    : "normal",
                  fontSize: this.props.fontSize ? this.props.fontSize : "15px",
                }}
                onClick={() => {
                  this.setState({ showSignUp: true, show: true });
                }}
              >
                Sign Up For Free
              </Button>
            </div>
          )}
          {show && (
            <Modal
              open={show}
              onClose={this.toggleModal}
              style={{
                // top: showSignUp ? "10%" : "15%",
                width: isMob ? "95%" : "50%",
                marginLeft: "auto",
                marginRight: "auto",
                height: "fit-content",
                position: "fixed",
                bottom: showSignUp ? "25%" : "50%",
                left: "0",
                top: "auto",
                overflowY: "auto",
              }}
            >
              <div style={{ backgroundColor: "white" }}>
                <div style={{ padding: "10px" }}>
                  <a
                    style={{
                      margin: "10px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    onClick={this.toggleModal}
                  >
                    X
                  </a>
                </div>

                {shouldRenderSignup && showSignUp && (
                  <Signup
                    formPreFillInfo={formPreFillInfo}
                    customColor={customColor}
                  />
                )}
                {shouldRenderLogin && !showSignUp && (
                  <Login
                    formPreFillInfo={formPreFillInfo}
                    isWeb={isWeb}
                    customColor={customColor}
                    callback={callback}
                  />
                )}
              </div>
            </Modal>
          )}
        </div>
      );
    }
    // console.log("rendering login button");
    return (
      <div
        style={{
          position: "initial",
          left: 0,
          top: 0,
          display: "inline-block",
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{
            textTransform: "none",
            width: this.props.width ? this.props.width : "auto",
            fontWeight: this.props.fontWeight
              ? this.props.fontWeight
              : "normal",
            fontSize: this.props.fontSize ? this.props.fontSize : "15px",
          }}
          onClick={() => this.setState({ show: true, showSignUp: true })}
        >
          {buttonText || "Login / Sign Up"}
        </Button>

        {/* {show && (
          <Modal open={show} onClose={() => this.setState({ show: false })}>
            <Container style={{ height: "65%" }}>
              {shouldRenderSignup && (
                <Signup formPreFillInfo={formPreFillInfo} />
              )}
              {formPreFillInfo.newUser === undefined && !isMob && (
                <VerticalLineBreak
                  margin="1em 1em 0 1em"
                  height="90%"
                  color="#1F3747"
                />
              )}
              {shouldRenderLogin && !isMob && <Login formPreFillInfo={formPreFillInfo} />}
            </Container>
          </Modal>
        )} */}
        {show && (
          <Modal
            open={show}
            onClose={this.toggleModal}
            style={{
              // top: showSignUp ? "10%" : "15%",
              width: isMob ? "95%" : "50%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "fit-content",
              position: "fixed",
              bottom: showSignUp ? "25%" : "50%",
              left: "0",
              top: "auto",
              overflowY: "auto",
            }}
          >
            <div style={{ backgroundColor: "white" }}>
              <div style={{ padding: "10px" }}>
                <a
                  style={{
                    margin: "10px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                  onClick={this.toggleModal}
                >
                  X
                </a>
              </div>

              {shouldRenderSignup && showSignUp && (
                <Signup
                  formPreFillInfo={formPreFillInfo}
                  customColor={customColor}
                />
              )}
              {/* {shouldRenderLogin && !showSignUp && (
                  <Login
                    formPreFillInfo={formPreFillInfo}
                    isWeb={isWeb}
                    customColor={customColor}
                    callback={callback}
                  />
                )} */}
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

export default LoginSignup;
